/**
 * Мульти-запросы, разделённые `;`: форматируем каждый оператор отдельно и склеиваем
 * с пустой строкой между ними (как backend _format_sql_clickhouse).
 * Разделитель совпадает с Python: re.split(r";\s*(?=\S|$)", ...).
 * «;» внутри строковых литералов не учитываем (как на бэкенде).
 */

import { format } from "sql-formatter";

/** Разбить SQL на отдельные операторы по `;` */
export function splitSqlStatements(sql: string): string[] {
  const sqlNorm = sql.replace(/\n{3,}/g, "\n\n").trim();
  if (!sqlNorm) return [];
  const rawParts = sqlNorm.split(/;\s*(?=\S|$)/);
  return rawParts.map((s) => s.trim()).filter(Boolean);
}

/** Склеить отформатированные операторы с дополнительным переносом между ними */
export function joinSqlStatements(statements: string[], endWithSemicolon: boolean): string {
  if (statements.length === 0) return "";
  let out = statements.join(";\n\n");
  if (endWithSemicolon) out += ";";
  return out;
}

/** Форматирование в редакторе (sql-formatter): каждый оператор отдельно + правка `func (` → `func(` */
export function formatSqlEditor(sql: string): string {
  const trimmed = sql.trim();
  if (!trimmed) return trimmed;
  const hadTrailingSemicolon = /;\s*$/.test(trimmed);
  const parts = splitSqlStatements(trimmed);
  if (parts.length === 0) return trimmed;
  const formatted = parts.map((stmt) => {
    try {
      let f = format(stmt);
      f = f.replace(/\b([A-Za-z_][A-Za-z0-9_]*)\s+\(/g, "$1(");
      return f;
    } catch {
      return stmt;
    }
  });
  return joinSqlStatements(formatted, hadTrailingSemicolon);
}
